import { ComponentType, ReplacementFilesComponentLearnersDto, Resubmitter } from '@cambridgeassessment/lib-ee-commons';
import { useAuth } from 'oidc-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../store';
import * as actions from '../../../../../store/replacementFiles/actions';
import * as thunks from '../../../../../store/replacementFiles/thunks';
import ToggleRow from './ToggleRow';

interface Props {
  entry: ReplacementFilesComponentLearnersDto;
  entryIndex: number;
  componentIndex: number;
  componentType: ComponentType;
}

export const ToggleRowLearner: React.FC<Props> = ({ entry, entryIndex, componentIndex, componentType }) => {
  const dispatch = useDispatch();
  const { userData } = useAuth();
  const { selectedRole } = useSelector((state: RootState) => state.userData);

  const onSubmissionToggle = (val: boolean) => {
    const resubmitter: Resubmitter | undefined = val
      ? {
          name: userData?.profile.name,
          email: userData?.profile.email,
          role: selectedRole?.name,
        }
      : undefined;

    dispatch(thunks.toggleSelectedLearner(entry, componentIndex, entryIndex, resubmitter));
    dispatch(actions.setSelectedLearner({ learnerBid: entry, entryIndex, componentIndex, val }));
  };

  let disabled, entryResubmission, tooltip;

  if (componentType === ComponentType.MODERATED && entry.absent) {
    disabled = true;
    entryResubmission = undefined;
    tooltip = 'This candidate is marked as absent.';
  } else if (componentType === ComponentType.MODERATED && !entry.marksSubmitted) {
    disabled = true;
    entryResubmission = undefined;
    tooltip = 'This candidate has no marks submitted.';
  } else {
    disabled = false;
    entryResubmission = entry.resubmission;
    tooltip = undefined;
  }

  return (
    <ToggleRow
      qaId={`toogle-learner-${entry.assessment.code}-${entry.componentNumber}-${entry.learner.number}-${entry.learner.uniqueId}`}
      title={`${entry.learner.number} ${entry.learner.name}`}
      resubmission={entryResubmission}
      onChange={onSubmissionToggle}
      disabled={disabled}
      tooltip={tooltip}
    />
  );
};

export default ToggleRowLearner;
